import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";

class SubscriptionService {
  // -------- Tenant / doctor / admin (tokenTenant or token) --------
  getCurrent = async (token) => {
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.CURRENT}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  };

  getUsage = async (token) => {
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.USAGE}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  };

  getPlans = async () => {
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.PLANS}`);
    return res.data;
  };

  getOrders = async (token) => {
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.ORDERS}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  };

  updateCurrent = async ({ plan_code, addon_doctor_count }, token) => {
    const res = await axios.put(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.CURRENT}`,
      { plan_code, addon_doctor_count },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  };

  checkoutSimulate = async ({ plan_code, addon_units, billing_cycle }, token) => {
    const res = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.CHECKOUT_SIMULATE}`,
      { plan_code, addon_units, billing_cycle },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  changeSimulate = async ({ plan_code, addon_units, billing_cycle }, token) => {
    const res = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.CHANGE_SIMULATE}`,
      { plan_code, addon_units, billing_cycle },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  getCatalog = async () => {
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.CATALOG}`);
    return res.data;
  };

  listTenantNotifications = async (token) => {
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.TENANT_NOTIFICATIONS}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  };

  markNotificationRead = async (id, token) => {
    const res = await axios.patch(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.TENANT_NOTIFICATION_READ(id)}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  // -------- Super-admin --------
  getSuperAdminPlans = async () => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.PLANS}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  };

  upsertSuperAdminPlan = async (code, payload) => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.put(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.PLAN_UPSERT(code)}`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  };

  getSuperAdminTenantCurrent = async (tenantId) => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.TENANT_CURRENT(tenantId)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  getSuperAdminTenantUsage = async (tenantId) => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.TENANT_USAGE(tenantId)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  getSuperAdminTenantOrders = async (tenantId) => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.TENANT_ORDERS(tenantId)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  getSuperAdminBillingSettings = async () => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.BILLING_SETTINGS}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };

  putSuperAdminBillingSettings = async (payload) => {
    const token = localStorage.getItem("superAdminToken");
    const res = await axios.put(
      `${API_BASE_URL}${API_ENDPOINTS.SUBSCRIPTION.SUPER_ADMIN.BILLING_SETTINGS}`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  };
}

export default new SubscriptionService();

